<template>
  <div>
    <div style="background-color: #fff">
      <a-skeleton :loading="loading" active />
      <WorkflowSteps v-if="!loading" :current="workflowData.workflow_current_step.index" :steps="workflowData.workflow_steps" :abstract="workflowData.steps_abstract" :template-id="workflowData.workflow_template ? workflowData.workflow_template.id : null" :current-step-id="workflowData.workflow_current_step.id" />
    </div>
    <WorkflowMove :project-id="workflowData.project_id" :workflow-id="workflowData.id" :workflow-status="workflowData.status.value" :current-step="workflowData.workflow_current_step" :associable-status="workflowData.associable_status" :processing-services="workflowMoreInfoData.processing_services" :template-id="workflowData.workflow_template ? workflowData.workflow_template.id : null" :can-add-mrd="workflowData.can_add_mrd" :br-info="dataSource" @onReload="onReload" />
    <a-card v-if="dataSource && brType !== 21" style="margin-bottom: 20px" :body-style="{ paddingBottom: '20px' }">
      <div style="font-size: 15px; font-weight: 600; margin-bottom: 8px">附件</div>
      <a-empty v-if="(!dataSource.files || dataSource.files.length == 0) && (!dataSource.images || dataSource.images.length == 0)" description="暂无附件" />
      <UploadImg :is-edit="false" :data-list="dataSource.images" />
      <UploadFile style="margin-top: 10px" :is-edit="false" :data-list="dataSource.files" />
    </a-card>
    <WorkflowChangelog ref="changelog" />
  </div>
</template>

<script>
import { workflowDetail, workflowMoreInfo, dissociationWorkflow } from '@/api/project/workflow';
import WorkflowSteps from '@/pages/business/requirement/components/BrWorkflowSteps';
// import WorkflowSteps from '@/pages/project/workflow/components/WorkflowSteps';
import WorkflowMove from '@/pages/project/workflow/components/WorkflowMove';
import WorkflowChangelog from '@/pages/project/workflow/components/WorkflowChangelog';
import UploadImg from '@/pages/business/requirement/components/UploadImg';
import UploadFile from '@/pages/business/requirement/components/UploadFile';
export default {
  components: { UploadImg, UploadFile, WorkflowSteps, WorkflowMove, WorkflowChangelog },
  props: {
    dataSource: {
      type: Object,
      default: null
    },
    brType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      currentStepId: 0,
      workflowMoreInfoData: {
        relation_workflow: [],
        content: [],
        description: [],
        apollo_address: [],
        sql_address: [],
        redis_change: [],
        services: [],
        bug_list: [],
        reject_bug_list: [],
        processing_services: [],
        problem_list: []
      },
      workflowId: 0,
      projectId: 0,
      workflowData: {
        workflow_steps: [],
        status: {
          value: null
        }
      }
    };
  },
  created() {},
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    init(flowId) {
      this.workflowId = flowId;
      this.getWorkFlowData();
    },
    onReload() {
      this.$emit('onReload');
    },
    // 获取工作流详情
    getWorkFlowData() {
      this.loading = true;
      workflowDetail({ project_id: this.projectId, workflow_id: this.workflowId })
        .then(res => {
          this.initData();
          this.$refs.changelog.getWorkflowChangelog(this.projectId, this.workflowId);
          this.workflowData = res.data;
          this.currentStepId = res.data.step_id;
          this.loading = false;
          this.emitIsReject(this.workflowData);
        })
        .catch(res => {
          this.loading = false;
          if (res.code === 4004) {
            this.$notification.info({
              message: '您访问的流程不存在',
              description: '已为您跳转至流程列表页'
            });
            // this.$router.push({ name: 'page:project:workflow:list' });
          }
        });
    },
    emitIsReject(workflowData) {
      if (workflowData.workflow_current_step && workflowData.workflow_current_step.release_list && workflowData.workflow_current_step.release_list.length > 0) {
        const rls = workflowData.workflow_current_step.release_list[0];
        if (rls.status === 5) {
          this.$emit('changeIsReject', true);
          return;
        }
      }
      this.$emit('changeIsReject', false);
    },
    // 获取工作流更多信息
    getWorkflowMoreInfo() {
      workflowMoreInfo({ project_id: this.projectId, workflow_id: this.workflowId })
        .then(res => {
          this.workflowMoreInfoData = res.data;
          if (res.data.deploying !== true) {
            clearInterval(this.timer);
          }
        })
        .catch(() => {
          clearInterval(this.timer);
        });
    },
    initData() {
      this.timer = setInterval(() => {
        this.getWorkflowMoreInfo();
      }, 5000);
      this.getWorkflowMoreInfo();
    }
  }
};
</script>

<style lang="less" scoped></style>
